/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FunctionComponent, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import ForgotPasswordForm from "./ForgotPasswordForm";
import { IRootState } from "../../config/reducers";
import { useTranslation } from "react-i18next";
import { AppLogo } from "@advapacs/common";
import { useAppDispatch } from "../../config/store";
import { AuthenticationLayout } from "@src/components/AuthenticationLayout";

const ForgotPassword: FunctionComponent = () => {
  const { t } = useTranslation("login");
  const dispatch = useAppDispatch();
  const { organisationSettings } = useSelector(
    (state: IRootState) => state.loginReducer
  );
  useEffect(() => {
    return () => {};
  }, [dispatch]);

  const { isAuthenticated, pathname } = useSelector(
    (state: IRootState) => state.loginReducer
  );
  if (isAuthenticated) {
    if (pathname !== "/") return <Navigate to={pathname} />;
  }

  const isForgetPassword = () => {
    return !organisationSettings || organisationSettings.canResetPassword;
  };

  return (
    <AuthenticationLayout isMultipleBrand={true}>
      <div className="logo flex-center">
        <AppLogo.CPBrandLogo noMargin width={220} height={70} />
      </div>

      <div className="mt-3">
        {isForgetPassword() && <ForgotPasswordForm />}
        {!isForgetPassword() && (
          <>
            <h5 className="text-center mb-3">{t("reset_password")}</h5>
            <div className="text-center ">{t("forget_password_denied")}</div>
            <div className="form-group mt-1">
              <Link className="btn btn-primary mt-2 btn-block btn-ladda" to="/">
                <i className="fa fa-angle-double-left ml-2" />
                {t("back_to_login")}
              </Link>
            </div>
          </>
        )}
      </div>
    </AuthenticationLayout>
  );
};

export default ForgotPassword;
